"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyOffset = void 0;
const common_1 = require("@finley-technologies/common");
/**
 * Applies a date offset to a DateTime date and returns a Util.FullDateStr
 */
const applyOffset = ({ date, offset, }) => {
    switch (offset.dayUnit) {
        case 'calendarDay':
            return common_1.date.datetimeToFullDateStr(date.plus({ days: offset.days }));
        case 'businessDay':
            // @jendevelops TODO: add holidays to abide by
            return common_1.date.addBusinessDays(common_1.date.datetimeToFullDateStr(date), offset.days);
        default:
            return (0, common_1.finleyAssertUnreachable)(offset.dayUnit);
    }
};
exports.applyOffset = applyOffset;
//# sourceMappingURL=offset.js.map